<template>
    <v-container fluid v-if="activeProject">
        <v-card class="mb-3">
            <v-card-text>
                <div class="title">Bot {{activeProject.bot_name}} - Bot Detail</div>
                <v-layout align-center>
                    <span class="mr-3">
                        <v-autocomplete
                            v-model="channel"
                            :label="$filters.capitalize($t('channel'))"
                            :items="channelList"
                            clearable
                        ></v-autocomplete>
                    </span>
                    <span class="mr-3">
                        <DatePicker
                            v-model="fromDate"
                            :label="$filters.capitalize($t('from'))"
                            :max="toDate"
                        ></DatePicker>
                    </span>
                    <span>
                        <DatePicker
                            v-model="toDate"
                            :label="$filters.capitalize($t('to'))"
                            :min="fromDate"
                            :max="today"
                        ></DatePicker>
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn depressed color="#878787" dark @click="loadDataTable" class="text-capitalize">
                        <v-icon class="mr-1">mdi-sync</v-icon>
                        {{$t('update')}}
                    </v-btn>
                    <v-btn depressed color="#42BE80" dark @click="getBotReportDetailsExcel" class="text-capitalize">
                        <v-icon class="mr-1">mdi-file-excel</v-icon>
                        {{$t('exportReport')}}
                    </v-btn>
                </v-layout>
            </v-card-text>
        </v-card>
        <v-card>
            <SimpleDataTable
                :headers="headers"
                :items="dataTable"
                :pagination.sync="pagination"
            >
                <template v-slot:sender_name="props">
                    <v-layout align-center>
                        <img
                            :src="`/img/channel_icon/${props.item.channel}.png`"
                            :alt="props.item.channel"
                            class="mr-1"
                            style="width: 20px;height: 20px;"/>
                        <span>{{props.item.sender_name}}</span>
                    </v-layout>
                </template>
                <template v-slot:rate_level="props">
                    <v-layout align-center>
                        <span>{{props.item.rate_level}}</span>
                        <v-icon size="16" color="yellow" style="text-shadow: 0 0 3px #000">mdi-star</v-icon>
                    </v-layout>
                </template>
            </SimpleDataTable>
        </v-card>
    </v-container>
</template>

<script>
import AgentDetails from '@/views/Agent/AgentDetails'
import SimpleDataTable from '@/components/SimpleDataTable'
import BotService from '@/services/bot.service'

export default {
    name: 'BotDetails',
    data () {
        return {
            baseUrl: process.env.BASE_URL,
        }
    },
    extends: AgentDetails,
    components: { SimpleDataTable },
    computed: {
        headers () {
            return this.$appService.correctHeaders([
                {
                    text: this.$t('time'),
                    value: 'created',
                    $value: item => this.$filters.formatDateTime(item.created)
                },
                {
                    text: this.$t('session_id'),
                    value: 'session_id',
                    id: 'session_id'
                },
                {
                    text: this.$t('user'),
                    value: 'sender_name',
                    type: 'custom',
                    id: 'sender_name'
                },
                {
                    text: this.$t('rated'),
                    value: 'rate_level',
                    type: 'custom',
                    id: 'rate_level'
                },
                {
                    text: this.$t('comment'),
                    value: 'rate_message'
                }
            ])
        }
    },
    methods: {
        getDataTablePromise () {
            return BotService.getBotReport(this.channel, this.fromDate, this.toDate, this.pagination)
        },
        getBotReportDetailsExcel () {
            return BotService.getBotReportDetailsExcel(this.channel, this.fromDate, this.toDate)
        }
    }
}
</script>

<style scoped>

</style>
